<sf-breadcrumb class="m-0">
    @for (breadcrumb of breadcrumbs(); track breadcrumb; let last = $last) {
        @if (breadcrumb?.label && (breadcrumb?.url?.slice(-1) === '/' || last)) {
            <sf-breadcrumb-item
                [active]="last"
                [url]="breadcrumb?.url"
                [attribs]="breadcrumb?.attributes"
                [linkProps]="breadcrumb?.linkProps">
                {{ breadcrumb?.label }}
            </sf-breadcrumb-item>
        }
    }
</sf-breadcrumb>
